import axios from 'axios';
import {objToURLParams} from '../utils';

export const UPDATE_FORM_FIELD = 'UPDATE_FORM_FIELD';
export const DIRECTIONS_REQUEST = 'DIRECTIONS_REQUEST';
export const DIRECTIONS_SUCCESS = 'DIRECTIONS_SUCCESS';
export const DIRECTIONS_FAILURE = 'DIRECTIONS_FAILURE';
export const SELECT_CURRENT_TRIP = 'SELECT_CURRENT_TRIP';
export const LOAD_CONFIG = 'LOAD_CONFIG';

export const updateFormField = event => {
    const {target} = event;
    console.log(event);
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked.toString() : target.value;
    const errors = event.error ? [event.error] : [];
    const params = event.params || {};
    console.log('value is ' + value);
    console.log(typeof value);
    return {
        type: UPDATE_FORM_FIELD,
        payload: {
            name,
            value,
            errors,
            params
        }
    };
};
// console.log(updateFormField);
export const fetchDirections = form => (dispatch, getState) => {
    const simplifiedForm = mapFormToKeyValuePairs(form);
    const queryParams = objToURLParams(simplifiedForm);
    const apiURL = getState().config.otpAPI;
    const openTripPlanner = axios.create({
        baseURL: apiURL,
        headers: {
            'content-type': 'application/json',
            'accept': 'application/json'
        }
    });

    dispatch({type:DIRECTIONS_REQUEST, payload:simplifiedForm});
    window.history.pushState(null, null, queryParams);


    openTripPlanner.get('/', {params: {...simplifiedForm}})
        .then(res => {
            dispatch({type:DIRECTIONS_SUCCESS, payload:res});
        })
        .catch(err => {
            dispatch({type:DIRECTIONS_FAILURE, payload:err});
        });
};


function mapFormToKeyValuePairs(form) {
    const formFields = Object.keys(form).map(fieldName => {
        return { key: fieldName, value: form[fieldName].value };
    });
    const simpleFormObject = formFields.reduce((obj, item) => {
        obj[item.key] = item.value;
        return obj;
    }, {});
    return simpleFormObject;
}


export const selectCurrentTrip = tripIndex => {
    return {
        type: SELECT_CURRENT_TRIP,
        payload: tripIndex
    };
};

export const loadConfig = config => {
    return {
        type: LOAD_CONFIG,
        payload: config
    };
};
